<script>
import Layout from "@/router/layouts/main";
import { mapState } from "vuex";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      "The document has been send": "Documento enviado com sucesso!",
      "Choose the file": "Escolha o arquivo",
      Send: "Enviar",
      Disapproved: "Reprovado",
      "On approval": "Em análise",
      Okay: "Aprovado",
      Resend: "Reenviar",
    },
    es: {
    },
  },
  components: {
    Layout,
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
  },
  data() {
    return {
      documents: null,

      choosed: null,
      file: null,

      modal: {
        loading: false,
        status: false,
        id: null,
        title: null,
        file: null,
      },
    };
  },
  methods: {
    getDocuments() {
      this.documents = null;

      api
        .get("documents")
        .then((response) => {
          if (response.data.status == 'success') {
            this.documents = response.data.list;
          } else {
            this.documents = [];
          }
        })
        .catch(() => {
          this.documents = [];
        });
    },
    setDocument() {
      this.modal.loading = true;

      const formData = new FormData();
      formData.append("file", this.file);

      api
        .post("documents/" + this.modal.id, formData, {
          headers: {
            "x-auth-token": localStorage.token,
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          if (data.status === "success") {
            this.$toast.success(data.message);
          } else {
            this.$toast.error(data.message);
          }

          this.getDocuments();
          this.modal.status = false;
          this.modal.loading = false;
        })
        .catch(() => {
          this.$toast.error("Erro ao enviar documento.");
          this.modal.loading = false;
        });
    },
    onFileSelected() {
      this.file = this.$refs.file.files[0];
      this.choosed = this.file.name;
    },
    addDocument(document) {
      if (
        document.status == "pending" ||
        document.status == "repproved" ||
        document.status == "empty" ||
        document.status == null
      ) {
        this.modal.status = true;
        this.modal.id = document.id;
        this.modal.title = document.name;
        this.choosed = null;
      }
    },
  },
  mounted() {
    this.getDocuments();
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Meus Documentos</h3>
        <p></p>
      </div>
    </div>

    <div class="bg-warning rounded p-4 mb-5">
      <h3>Para finalizar seu cadastro de consultor é necessário anexar os documentos obrigatórios.</h3>
      <h3>Sem os documentos você ainda não estará apto a se tornar um consultor.</h3>
    </div>

    <div class="row justify-content-center" v-for="(document, index) in documents" :key="index">
      <div class="col-md-12 col-lg-7 col-xl-6">
        <div class="card mb-1">
          <div class="card-body p-4">
            <div class="d-md-flex justify-content-between align-items-center">
              <h5 class="font-weight-medium m-0">
                {{ document.name }}
              </h5>
              <div v-if="document.status">
                <div class="bg-warning rounded d-inline-block p-2 px-3 mr-2 mt-3 mt-md-0 text-uppercase" v-if="document.status == 'pending'">
                  Em análise
                </div>
                <div class="bg-success rounded d-inline-block p-2 px-3 mr-2 mt-3 mt-md-0 text-uppercase" v-else-if="document.status == 'approved'">
                  Aprovado
                </div>
                <template v-if="document.url">
                  <a class="btn btn-info btn-sm-block text-uppercase p-2 px-3" target="_blank" :href="document.url">
                    Ver
                  </a>
                  <button class="btn btn-default btn-block btn-md-inline text-uppercase mt-2" @click="addDocument(document)">
                    Reenviar
                  </button>
                </template>
                <template v-else>
                  <button class="btn btn-default btn-block btn-md-inline text-uppercase mt-3 mt-md-0" @click="addDocument(document)">
                    Enviar
                  </button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="modal.status" :title="modal.title" modal-class="modal-right" hide-footer>
      <div class="col-12">
        <b-form @submit.prevent="setDocument">
          <div class="d-flex align-items-center justify-content-between pb-2">
            <div class="input-group">
              <div class="custom-file">
                <input type="file" id="file" ref="file" class="custom-file-input" @change="onFileSelected" aria-describedby="inputGroupFileAddon01" />
                <label class="custom-file-label" for="file" v-if="choosed == null">Escolher arquivo</label>
                <label class="custom-file-label" for="file" v-else>{{ choosed }}</label>
              </div>
            </div>
          </div>
          <b-button class="btn-lg btn-block text-uppercase" type="submit" variant="default" :disabled="modal.loading">
            Enviar
            <b-spinner v-if="modal.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </b-button>
        </b-form>
      </div>
    </b-modal>
  </Layout>
</template>
